<template>
  <div id="live-map-controls-sidebar-weather">
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="active"
      class="items-no-padding"
    >
      <div class="h-full">
        <div
          class="customizer-header flex items-center justify-between px-6"
        >
          <div>
            <span class="aisea-text-18-700-white">気象海象</span>
          </div>
          <feather-icon
            icon="XIcon"
            @click.stop="setActive(false)"
            svgClasses="live-map-controls-close"
            class="cursor-pointer"
          ></feather-icon>
        </div>

        <vs-divider class="mb-0 mt-0" :color="AISEA_COLOR.GRAY"/>

        <vs-collapse>
          <vs-collapse-item class="weather">
            <div slot="header" class="aisea-text-16-400-white" id="weather-element-collapse-item-header">
              海象・気圧
            </div>
            <weather-metocean/>
          </vs-collapse-item>
          <vs-collapse-item class="mt-4">
            <div slot="header" class="aisea-text-16-400-white" id="weather-point-collapse-item-header">
              沖波ポイント予測
            </div>
            <weather-point/>
          </vs-collapse-item>
          <vs-collapse-item class="mt-4">
            <div slot="header" class="aisea-text-16-400-white" id="weather-typhoon-collapse-item-header">
              台風
            </div>
            <weather-typhoon/>
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import weatherMetocean from "./items/Metocean";
import weatherPoint from "./items/Point";
import weatherTyphoon from "./items/Typhoon";
import moment from "moment-timezone";
import {ColorMixin} from "@/mixins";


// Store
const {
  mapState: mapStateOfLiveMap,
  mapMutations: mapMutationsOfLiveMap,
} = createNamespacedHelpers("liveMap");

export default {
  mixins: [ColorMixin],
  components: {
    weatherMetocean,
    weatherPoint,
    weatherTyphoon
  },
  props: {
    map: Object
  },
  data() {
    return {
      init:false,
      vessels: [],
      active: false,
      settings: {
        maxScrollbarLength: 50,
        wheelSpeed: 0.6
      },
    };
  },
  watch: {
    activeWeatherSidebar(val) {
      if (val) {
        this.setActive(val)
        if(!this.init){
          setTimeout(() => {
            this.onClickCollapse()
          }, 500);
          this.init = true
        }
      }
    }
  },
  computed: {
    ...mapStateOfLiveMap({
      activeWeatherSidebar: state => state.activeWeatherSidebar
    }),
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    }
  },
  methods: {
    ...mapMutationsOfLiveMap([
      "SET_METOCEAN_INITIAL_DATETIME",
      "SET_ACTIVE_WEATHER_SIDEBAR",
    ]),
    onClickCollapse(){
      document.getElementById('weather-element-collapse-item-header').click()
      document.getElementById('weather-point-collapse-item-header').click()
      document.getElementById('weather-typhoon-collapse-item-header').click()
    },
    setActive(isActive) {
      if (isActive) {
        let beginningOfDay = moment().startOf('day').unix()
        this.SET_METOCEAN_INITIAL_DATETIME(beginningOfDay)
      }
      this.active = isActive;
      this.SET_ACTIVE_WEATHER_SIDEBAR(isActive)
    },
    updatePrimaryColor(color) {
      this.primaryColor = color;
      this.$vs.theme({primary: color});
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#live-map-controls-sidebar-weather {
  .vs-collapse-item--header{
    padding-bottom: 5px;
    padding-left: 0;
  }
  .vs-collapse{
    padding: 0 20px 20px;
  }
  .vs-collapse-item--content{
    border-radius: 5px;
  }
  .header-label{
    color: $aisea-white;
  }

  .icon-header {
    color: $aisea-white;
  }
  .con-content--item{
    background-color: $aisea-blue-gray;
  }

  .vs-sidebar {
    width: 100%;
    max-width: 375px;
    background-color: $aisea-dark-blue;
    opacity: 1.0;
    @media screen and (min-width: $min-width-ipad-pro-11) {
      max-width: 400px;
    }
  }

  .customizer-header {
    height: 4.5rem;
    top: 0px;
    position: sticky;
    background-color: $aisea-dark-blue;
    z-index: 1;
  }

  .vs-sidebar--items {
    overflow-y: auto;
  }

  .vs-switch:not(.vs-switch-active) {
    background: rgb(239, 239, 239);
  }

  .vs-collapse-item--icon-header {
    right: -15px;

    .vs-icon {
      font-size: 2rem;
    }
  }
  
  .vs-collapse-item {
    border-bottom: 0;
  }
}
</style>
